// Apolo IDE — seletor puro de runs em segundo plano (auditoria 2026-07-02).
//
// Quando você troca de perfil com um agente rodando, a sessão sai da lista
// (escopo estrito por perfil, #428) mas o run CONTINUA no agentRunStore. Este
// seletor identifica as runs VIVAS que NÃO estão visíveis na lista do perfil
// atual — são as "em segundo plano" que a barra global mostra/permite parar.

/**
 * @param {{ streamingSessionIds?: Record<string,boolean>, sessions?: Array<{id:string}>, runMeta?: Record<string,{name?:string,profileId?:string|null}> }} codeState
 * @returns {Array<{ sessionId: string, name: string, profileId: string|null }>}
 */
export function selectBackgroundRuns(codeState = {}) {
  const streaming = codeState.streamingSessionIds || {};
  const visible = new Set((codeState.sessions || []).map((s) => s.id));
  const meta = codeState.runMeta || {};
  const out = [];
  for (const id of Object.keys(streaming)) {
    if (!streaming[id]) continue;
    if (visible.has(id)) continue; // visível no perfil atual → tem dot + Stop normal
    out.push({
      sessionId: id,
      name: meta[id]?.name || '(sessão)',
      profileId: meta[id]?.profileId ?? null,
    });
  }
  return out;
}
